<template>
    <div>
        <!--搜索表单-->
        <div class="search-box selectType">
            <el-form ref="searchForm"  :inline="true" :rules="searchRules" :model="searchForm" >
                <el-form-item label="年份:" prop="year">
                    <el-date-picker
                            style="width: 150px"
                            size="mini"
                            v-model="searchForm.year"
                            type="year"
                            placeholder="选择年份"
                            format="yyyy"
                            value-format="yyyy">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="录取状态:" prop="admissionStatus">
                    <el-select v-model="searchForm.admissionStatus" size="mini" filterable placeholder="请选择录取状态">
                        <el-option v-for="item in admissionStatusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="考生姓名:" prop="name">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.name" placeholder="请输入考生姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号:" prop="idCard">
                    <el-input size="mini" maxlength="18" show-word-limit  v-model="searchForm.idCard" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="备注:" prop="remark">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="准考证号:" prop="ticketNumber">
                    <el-input size="mini" maxlength="18" show-word-limit  v-model="searchForm.ticketNumber" placeholder="请输入准考证号"></el-input>
                </el-form-item>
                <el-form-item label="专业名称:" prop="majorId">
                    <el-select v-model="searchForm.majorId" size="mini" filterable @change="getMajorItemList(searchForm.majorId)" placeholder="请选择专业">
                        <el-option v-for="item in majorList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分数1:" prop="scoreLookStart">
                    <el-input-number size="mini" v-model="searchForm.scoreLookStart" :precision="1" :step="0.1" :max="1000"></el-input-number>
                    <el-select v-model="searchForm.scoreLookType" style="margin-left: 20px" size="mini" filterable placeholder="请选择查询类型">
                        <el-option v-for="item in scoreLookTypeList" :key="item.value" :label="item.id" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分数2:" v-if="searchForm.scoreLookType==4 || searchForm.scoreLookType==5" prop="scoreLookEnd">
                    <el-input-number size="mini" v-model="searchForm.scoreLookEnd" :precision="1" :step="0.1" :max="1000"></el-input-number>
                </el-form-item>
                <el-form-item>
                    <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysStudentAdmission-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                    <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                    <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                    <el-button size="mini" type="primary" plain v-display:sysStudentAdmission-delete @click="batchAdmission(1,'录取')" >批量录取</el-button>
                    <el-button size="mini" type="danger" plain v-display:sysStudentAdmission-delete @click="batchAdmission(2,'不录取')" >批量不录取</el-button>
                    <el-button size="mini" type="success" plain v-display:sysStudentAdmission-export icon="el-icon-download" @click="exportsysStudentAdmission" >导出</el-button>
                    <el-button size="mini" type="success" plain v-display:sysStudentAdmission-export icon="el-icon-download" @click="setLevel" >一键排名</el-button>

                </el-form-item>
            </el-form>
         </div>
        <!--表格-->
        <el-table border size="mini" class="table-ui" :stripe="true"  :data="tableData" @selection-change="changeFun"  @sort-change="sortChange" >
            <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
            <el-table-column type="expand" label="展开录取" width="80">
                <div slot-scope="scope">
                    <div style="margin-left: 30px">
                        <el-button type="text" size="mini"  v-if="tableData[scope.$index].admissionStatus==0 || tableData[scope.$index].admissionStatus==4" v-display:sysStudentAdmission-update @click="admission(tableData[scope.$index].stuId,'1','录取')" style="color: green">录取</el-button>
                        <el-button type="text" size="mini"  v-else v-display:sysStudentAdmission-update disabled>录取</el-button>
                        <el-button type="text"  size="mini"  v-if="tableData[scope.$index].admissionStatus==2 || tableData[scope.$index].admissionStatus==0" v-display:sysStudentAdmission-delete @click="admission(tableData[scope.$index].stuId,'2','不录取')" style="color: red">不录取</el-button>
                        <el-button type="text"  size="mini"  v-else v-display:sysStudentAdmission-delete disabled>不录取</el-button>
                    </div>
                </div>
            </el-table-column>
            <el-table-column type="index" label="序号" width="60px"></el-table-column>
            <el-table-column show-overflow-tooltip prop="studentId" label="录取状态">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.admissionStatus==2" class="item" effect="dark" content="达到录取条件予以录取" placement="top">
                        <span style="color: green">已录取</span>
                    </el-tooltip>
                    <el-tooltip v-else-if="scope.row.admissionStatus==4" class="item" effect="dark" content="达到录取条件予以录取" placement="top">
                        <span style="color: red">不录取</span>
                    </el-tooltip>
                    <el-tooltip v-else-if="scope.row.admissionStatus==0" class="item" effect="dark" content="没有进行录取操作" placement="top">
                        <span style="color: cornflowerblue">待录取</span>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" content="数据被篡改" placement="top">
                        <span style="color: red">被篡改</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ticketNumber" label="准考证号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="考生姓名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="idCard" label="身份证号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="majorName" label="报考专业"></el-table-column>
            <el-table-column show-overflow-tooltip prop="scoreSeqInfo" label="科目得分">
                <template slot-scope="scope">
                    <p v-for="(majorItem,index) in scope.row.majorItemNameArray" style="margin-right: 10px">{{majorItem}}:<span style="font-weight: bold">{{scope.row.scoreInfoArray[index]}}</span></p>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="sum" label="考试总分"></el-table-column>
            <el-table-column show-overflow-tooltip prop="level" label="专业排名"></el-table-column>
            <el-table-column fixed="right" label="操作" width="80"  >
                <template slot-scope="scope">
                    <!--<el-button type="text" size="mini"  v-if="scope.row.admissionStatus==0" v-display:sysStudentAdmission-update @click="admission(scope.row.stuId,'1','录取')" style="color: green">录取</el-button>-->
                    <!--<el-button type="text" size="mini"  v-else v-display:sysStudentAdmission-update disabled>录取</el-button>-->
                    <!--<el-button type="text"  size="mini"  v-if="scope.row.admissionStatus==2" v-display:sysStudentAdmission-delete @click="admission(scope.row.stuId,'0','不录取')" style="color: red">不录取</el-button>-->
                    <!--<el-button type="text"  size="mini"  v-else v-display:sysStudentAdmission-delete disabled>不录取</el-button>-->
                    <el-button type="text"  size="mini" @click="getAdmissionHistory(scope.row.stuId)">录取记录</el-button>
                </template>
            </el-table-column>
            <div slot="empty"><no-data></no-data></div>
        </el-table>
        <el-pagination
                style="margin-top: 10px;padding-bottom: 20px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchForm.pager.totalCount"
                :page-size="searchForm.pager.pageSize"
                :current-page.sync="searchForm.pager.page"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                @size-change="sizeChange"
                @current-change="currentChange"
                @prev-click="currentChange"
                @next-click="currentChange"
        ></el-pagination>
        <!--添加或者修改表单-->
        <el-dialog :close-on-click-modal="false" :title="dialog.title"   width="1000px" :visible.sync="dialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" :rules="rules" ref="upsertForm" label-width="100px" :inline="true">
                <input type="hidden" :value="upsertForm.id">
                          <el-form-item label="操作人编" prop="adminId">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.adminId" placeholder="请输入操作人编" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="操作恩昵" prop="adminName">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.adminName" placeholder="请输入操作恩昵" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="学生编号" prop="studentId">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studentId" placeholder="请输入学生编号" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="考试总分" prop="sumScore">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.sumScore" placeholder="请输入考试总分" auto-complete="off"></el-input>
                         </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini"  @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini"  type="primary" v-if="dialog.title=='增加'" v-display:sysStudentAdmission-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                <el-button plain size="mini"  type="primary" v-else v-display:sysStudentAdmission-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--查看详情-->
        <el-dialog :close-on-click-modal="false" title="查看"   width="1000px" :visible.sync="lookVisible">
            <div>
            <el-form class="upsertForm" :inline="true" label-width="100px">
                       <el-form-item label="操作人编" prop="adminId">
                        <el-input size="mini" v-model="upsertForm.adminId" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="操作恩昵" prop="adminName">
                        <el-input size="mini" v-model="upsertForm.adminName" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="学生编号" prop="studentId">
                        <el-input size="mini" v-model="upsertForm.studentId" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="考试总分" prop="sumScore">
                        <el-input size="mini" v-model="upsertForm.sumScore" readonly auto-complete="off"></el-input>
                        </el-form-item>
            </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" class="large" @click="lookVisible = false">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
            <div v-if="dialogExcel.title=='导入结果'">
            <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                <el-button size="mini">导入总数</el-button>
            </el-badge>
            <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入成功</el-button>
            </el-badge>
            <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入失败</el-button>
            </el-badge>
            <!--表格-->
            <el-table v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                    <el-table-column prop="adminId" label="操作人编"></el-table-column>
                    <el-table-column prop="adminName" label="操作恩昵"></el-table-column>
                    <el-table-column prop="studentId" label="学生编号"></el-table-column>
                    <el-table-column prop="sumScore" label="考试总分"></el-table-column>
                    <el-table-column prop="updateTime" label="修改时间"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间"></el-table-column>
            </el-table>
        </div>
            <div v-if="dialogExcel.title=='导入'">
                <el-upload class="lead-in-th"
                           style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                           :action="uploadUrl"
                           :headers="headers"
                           multiple
                           :show-file-list="false"
                           :on-success="handlesysStudentAdmissionSuccess"
                           :before-upload="beforesysStudentAdmissionUpload">
                    <div class="" style="width: 440px;height: 50px;">导入</div>
                </el-upload>
                <div class="lead-in-th" @click="exportsysStudentAdmissionModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
            </div>
        </el-dialog>
        <el-drawer
                title="录取记录"
                :visible.sync="drawer"
                :direction="direction"
                :before-close="handleClose">
            <div class="block" style="margin-left: 20px">
                <div class="radio" style="margin-bottom: 10px">
                    排序：
                    <el-radio-group v-model="reverse">
                        <el-radio :label="true">倒序</el-radio>
                        <el-radio :label="false">正序</el-radio>
                    </el-radio-group>
                </div>
                <el-timeline :reverse="reverse">
                    <el-timeline-item
                            v-for="(item, index) in admissionHistoryList"
                            :key="index"
                            :timestamp="admissionHistoryList.createTime">
                        <div>
                            <span v-if="item.admissionStatus==1" class="el-icon-success" style="color: green">
                            已录取
                        </span>
                            <span v-else class="el-icon-close" style="color: red">
                            未录取
                        </span>
                        </div>
                        <div style="margin-top: 10px">
                            <span class="el-icon-edit-outline">总分</span><span style="margin-left: 10px">:{{item.sumScore}}</span><span style="float: right;margin-right: 10px" class="el-icon-s-custom">{{item.adminName}}</span>
                        </div>
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysStudentAdmission",
        components: { noData },
        data() {
            return {
                searchForm:{
                    adminId: '',
                    adminName: '',
                    studentId: '',
                    sumScore: '',
                    year:'',
                    admissionStatus:'',
                    name:'',
                    idCard:'',
                    ticketNumber:'',
                    scoreLookStart:'',
                    scoreLookType:'',
                    scoreLookEnd:'',
                    updateTime: '',
                    createTime: '',
                    pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:'name,idCard,ticketNumber,remark'
                    }
                },
                tableData: [],
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    studentId:'',
                    sumScore:'',
                    year:'',
                    admissionStatus:'',
                    ticketNumber:'',
                    name:'',
                    updateTime:'',
                    createTime:''
                },
                searchRules: {
                          adminId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adminName: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          sumScore: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                rules: {
                          adminId: [
                                  { required: true, message: '请输入操作人编', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adminName: [
                                  { required: true, message: '请输入操作恩昵', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentId: [
                                  { required: true, message: '请输入学生编号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          sumScore: [
                                  { required: true, message: '请输入考试总分', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  { required: true, message: '请输入修改时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  { required: true, message: '请输入创建时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                lookVisible:false,
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysStudentAdmission/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                admissionStatusList:[
                    {"name":"待录取","value":"0"},
                    {"name":"已录取","value":"1"},
                    {"name":"不录取","value":"2"},
                ],
                ajorList:[],
                admissionHistoryList:[],
                drawer: false,
                direction: 'rtl',
                reverse: true,
                scoreLookTypeList:[
                    {"id":">","value":"0"},
                    {"id":">=","value":"1"},
                    {"id":"<","value":"2"},
                    {"id":"<=","value":"3"},
                    {"id":"范围不等于","value":"4"},
                    {"id":"范围等于","value":"5"},
                ],
                majorList:[],
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
            this.getMajorList();
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].stuId);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            showAddDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title='增加';
                objUtil.setToDefault(this.upsertForm);
                this.$nextTick(()=>{
                    this.$refs.upsertForm.clearValidate();
                });
            },
            showUpdateDialog(id){
                axios({
                    url:`${home}/sysStudentAdmission/update/findSysStudentAdmissionById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                    this.dialog.dialogFormVisible=true;
                    this.dialog.title = '修改';
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }).catch(error=>{

                })

            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysStudentAdmission/${this.dialog.title==='增加'?'saveSysStudentAdmission':'update/updateSysStudentAdmission'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit();
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentAdmission/deleteSysStudentAdmission/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })
                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysStudentAdmission/findSysStudentAdmissionsByScore`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
                this.searchForm.scoreLookType = null;
                this.searchForm.scoreLookStart = null;
                this.searchForm.scoreLookEnd = null;
            },
            toLook($event,id){
                this.lookVisible=true;
                axios({
                    url:`${home}/sysStudentAdmission/look/lookSysStudentAdmissionById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                }).catch(error=>{
                    console.log(error);
                })
            },
            leadingInsysStudentAdmission() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportsysStudentAdmission() {
                axios({
                    url: `${home}/sysStudentAdmission/exportSysStudentAdmission`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "学生录取.xls");
                });
            },
            exportsysStudentAdmissionModule() {
                axios({
                    url: `${home}/sysStudentAdmission/exportSysStudentAdmissionModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "sysStudentAdmission模板.xls");
                });

            },
            handlesysStudentAdmissionSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforesysStudentAdmissionUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentAdmission/batchDeleteSysStudentAdmission`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            batchAdmission(status,handel){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量"+handel+"该学生吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentAdmission/batchAdmission`,
                        method: "POST",
                        data: {
                            "rowData": this.rowData,
                            "admissionStatus":status
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: status==1?"录取":"不录取"+"成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "warning",
                        message: "取消录取!"
                    });
                });
            },
            admission(id,status,handel){
                this.$confirm("确认"+handel+"该学生吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentAdmission/admission`,
                        method: "POST",
                        data:{
                            "studentId":id,
                            "admissionStatus":status
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: handel+"成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "warning",
                        message: "取消录取!"
                    });
                });
            },
            getMajorList(){
                axios({
                    url: `${home}/sysDdList/getMajorList`,
                    method: "GET",
                }).then(res => {
                    this.majorList = res.data;
                });
            },
            getAdmissionHistory(id){
                axios({
                    url: `${home}/sysStudentAdmission/findSysStudentAdmissionAllListByStuId/${id}`,
                    method: "GET",
                }).then(res => {
                    this.admissionHistoryList = res.data;
                    this.drawer = true;
                });
            },
            handleClose(done) {
                done();
            },
            setLevel(){
                axios({
                    url: `${home}/sysStudentAdmission/setLevel`,
                    method: "GET",
                }).then(res => {
                    this.submit();
                    this.$message({
                        type: "success",
                        message: "操作成功!"
                    });
                });
            }

        }
    }
</script>
<style lang="scss">
    .selectType{
        .el-input__inner{
            width: 150px;
        }
        .el-input .el-input--mini {
            width: 150px;
        }
        .el-input-number{
            width: 150px;
        }
    }
</style>